$(".webcast-atc").click(function(e){
  e.preventDefault();
  var this_btn = $(this);
  var var_id = $(this).attr('data-variant-id');
  $(this).addClass('btn--loading');
  var addData = {
    'id':var_id,
    'quantity':1
  };

  fetch(theme.routes.cartAdd, {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  }).then(function(response) {
    return response.json();
  }).then(function(data) {
    if (data.status === 422) {
      alert('Something wrong! Please reload page.');
      location.reload();
    } 
    else {
      var product = data;
      setTimeout(function(){
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: $(this)
          }
        }));
        this_btn.removeClass('btn--loading');
      }, 1200);
    }
  }).catch(function(err) {
    alert('Something wrong! Please reload page.');
    location.reload();
  });
});
function replace_saving_amount() {
  fetch("".concat(theme.routes.cartPage, "").concat("?timestamp=").concat(Date.now()), {
    credentials: 'same-origin',
    method: 'GET'
  }).then(function (content) {
      content.text().then(function (html) {
        var tempElement = document.createElement('div');
        tempElement.innerHTML = html;
        //console.log(html);
        document.querySelector(".cart__item-row-saving").innerHTML = tempElement.querySelector('.cart__item-row-saving').innerHTML;
      });
  });
}
document.addEventListener('ajaxProduct:added', function(evt) {
  replace_saving_amount();
});
document.addEventListener('cart:updated', function(evt) {
  replace_saving_amount();
});




    document.getElementById('sb-hair-button').addEventListener('click', function() {
        const section = document.getElementById('shopify-section-template--17339510096096__collection-header');
        section.scrollIntoView({ behavior: 'smooth' });
    });


document.addEventListener('DOMContentLoaded', function() {
    var isProductAdded = false;
    var link = document.querySelector('.sb-upsell-link'); // Select the link

    link.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent the default link behavior

        if (!isProductAdded) {
            addVariantToCart();
            isProductAdded = true;
            // Change the style of the link
            this.style.backgroundColor = '#fa0d3d';
            this.style.justifyContent = 'flex-end';
        } else {
            removeVariantFromCart();
            isProductAdded = false;
            // Revert the style of the link to original
            this.style.backgroundColor = ''; // Revert to original background color
            this.style.justifyContent = 'flex-start'; // Revert to original justify-content
        }
    });


    function addVariantToCart() {
        var data = {
            items: [{
                id: 42349153124576, // Product variant ID
                quantity: 1
            }]
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        .then(response => {
            if (response.ok) {
                console.log('Variant added to cart');
            } else {
                console.error('Failed to add variant to cart');
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }

    function removeVariantFromCart() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let lineItem = cart.items.find(item => item.id === 42349153124576);
                if (lineItem) {
                    return fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ id: lineItem.key, quantity: 0 })
                    });
                } else {
                    throw new Error('Item not found in cart');
                }
            })
            .then(response => {
                if (response.ok) {
                    console.log('Variant removed from cart');
                } else {
                    console.error('Failed to remove variant from cart');
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }
});



  document.getElementById('sb-hair-button').addEventListener('click', function() {
    const collectionGridWrapper = document.querySelector('.collection-grid__wrapper');
    
    if (collectionGridWrapper) {
        collectionGridWrapper.scrollIntoView({ behavior: 'smooth' });
    }
});



